// Customizable Area Start
import React, { Component } from "react";
import { Box, styled } from "@mui/material";
const SuccessSign = require("./assets/success_check.svg").default;
const ErrorSign = require("./assets/error_sign.svg").default;

const INFO_SIGNS = {
  success: SuccessSign,
  error: ErrorSign,
};

const InfoIconWrapper = styled(Box)({
  height: "clamp(60px, 14vw, 90px)",
  width: "clamp(60px, 14vw, 90px)",
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "linear-gradient(180deg, #8077FF 0%, #652784 100%)",
  "& img": {
    height: "clamp(30px, 5vw, 45px)",
    width: "clamp(30px, 5vw, 45px)",
  },
});

type InfoType = "success" | "error";

interface Props {
  infoType: InfoType;
}

class CustomInfoIcon extends Component<Props> {
  render() {
    const { infoType } = this.props;
    return (
      <InfoIconWrapper>
        <img src={INFO_SIGNS[infoType]} alt="Icon" />
      </InfoIconWrapper>
    );
  }
}

export default CustomInfoIcon;
// Customizable Area End
